module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.globals.isAccessAllowed('LoopOp_KPIs_ReadAll')) ? _c('div', [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "kpi-top-panel"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.refreshEnabled || !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        return _vm.getKpiData()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("refresh")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0000) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        return _vm.openKpiGroupEditModal()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("group_work")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0010) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        return _vm.openEditKpiDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0001) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        return _vm.openKpiAssignmentDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("assignment")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0017) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        return _vm.openKpiLanguageDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("language")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0009) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "disabled": !_vm.selectedClient
    },
    on: {
      "click": function($event) {
        _vm.showKPICopyModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("content_copy")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.lang.KM0021) + "\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group selectbar nopadding"
  }, [(
    !_vm.feature.isAudiTarget || !_vm.feature.isEnabled('audi_importers')
  ) ? _c('div', {
    staticClass: "select-filter-container",
    staticStyle: {
      "float": "left"
    }
  }, [_c('select2', {
    ref: "clientSelect",
    staticClass: "form-control",
    attrs: {
      "id": "kpi-management-client-select",
      "afterChange": _vm.onClientSelection,
      "allowClear": true,
      "placeholder": _vm.lang.KM0011
    },
    model: {
      value: (_vm.selectedClient),
      callback: function($$v) {
        _vm.selectedClient = $$v
      },
      expression: "selectedClient"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                " + _vm._s(client.ClientName) + "\n              ")])
  }), 0)], 1) : _c('div', {
    staticClass: "select-filter-container",
    staticStyle: {
      "float": "left"
    }
  }, [_c('select2', {
    ref: "importerSelect",
    staticClass: "form-control",
    attrs: {
      "id": "kpi-management-importer-select",
      "afterChange": _vm.selectedImporterChanged,
      "allowClear": true,
      "placeholder": _vm.lang.KM0018
    },
    model: {
      value: (_vm.selectedImporter),
      callback: function($$v) {
        _vm.selectedImporter = $$v
      },
      expression: "selectedImporter"
    }
  }, _vm._l((_vm.importerList), function(importer) {
    return _c('option', {
      key: importer.ImporterGuid,
      domProps: {
        "value": importer.ImporterGuid
      }
    }, [_vm._v("\n                " + _vm._s(importer.ImporterName) + "\n              ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "select-filter-container"
  }, [_c('select2', {
    ref: "projectSelect",
    staticClass: "form-control",
    attrs: {
      "id": "kpi-management-project-select",
      "disabled": _vm.clientProjectList.length < 1,
      "allowClear": true,
      "placeholder": _vm.lang.KM0012,
      "afterChange": _vm.doFiltering
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  }, _vm._l((_vm.clientProjectList), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                " + _vm._s(project.ProjectName) + "\n              ")])
  }), 0)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('div', {
    staticClass: "form-group searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "id": "KPIManagementSearchInput",
      "placeholder": _vm.lang.KM0002
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        (_vm.selectedPage = 1),
        (_vm.selectedKpiGuid = ''),
        (_vm.selectedKpiData = {}),
        _vm.doFiltering()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 nopadding"
  }, [_c('ul', {
    staticClass: "pagination-fonts pagination btn-group"
  }, [_c('li', [_vm._m(0), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "elementsPerPageDropdown",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM0003))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 20
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 20)
      }
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 50
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 50)
      }
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 100
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 100)
      }
    }
  }, [_vm._v("100")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 200
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 200)
      }
    }
  }, [_vm._v("200")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-element",
    class: {
      'dropdown-active': _vm.pageSize == 500
    },
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 500)
      }
    }
  }, [_vm._v("500")])])])], 1), _vm._v(" "), _c('li', {
    class: {
      disabled: !_vm.filteredKpiData.length || _vm.selectedPage == 1,
    },
    on: {
      "click": function($event) {
        return _vm.updatePaging(1, 0)
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "firstPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM0004))])], 1), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage > 4) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getVisiblePages()), function(pageNumber) {
    return _c('li', {
      key: pageNumber,
      class: {
        active: _vm.selectedPage == pageNumber
      },
      on: {
        "click": function($event) {
          return _vm.updatePaging(pageNumber, 0)
        }
      }
    }, [_c('a', {
      attrs: {
        "role": "button"
      }
    }, [_vm._v(_vm._s(pageNumber))])])
  }), _vm._v(" "), (_vm.numberOfPages() > 7 && _vm.selectedPage < _vm.numberOfPages() - 3) ? _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button"
    }
  }, [_vm._v("...")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: {
      disabled:
        !_vm.filteredKpiData.length || _vm.selectedPage == _vm.numberOfPages(),
    },
    on: {
      "click": function($event) {
        _vm.updatePaging(_vm.numberOfPages(), 0)
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "lastPageButton",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM0005))])], 1), _vm._v(" "), _c('li', {
    staticClass: "disabled"
  }, [_c('a', {
    attrs: {
      "role": "button",
      "id": "kpisTotalElementsCounter"
    }
  }, [_vm._v(_vm._s(_vm.filteredKpiData.length))]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "kpisTotalElementsCounter",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM0020))])], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "table-space main-table-scrollbar"
  }, [_c('table', {
    staticClass: "table table-striped table-hover main-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('KPICode')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0006) + "\n                  "), (_vm.showSortArrow('KPICode', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('KPICode', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('KPIShortText')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0007) + "\n                  "), (_vm.showSortArrow('KPIShortText', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('KPIShortText', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('KPILongText')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0008) + "\n                  "), (_vm.showSortArrow('KPILongText', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('KPILongText', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('KPIGroups')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0010) + "\n                  "), (_vm.showSortArrow('KPIGroups', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('KPIGroups', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('ClientName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0013) + "\n                  "), (_vm.showSortArrow('ClientName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('ClientName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]) : _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Importers')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0019) + "\n                  "), (_vm.showSortArrow('Importers', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Importers', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('Projects')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0015) + "\n                  "), (_vm.showSortArrow('Projects', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('Projects', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('SurveyIdString')
      }
    }
  }, [_vm._v("\n                  Survey\n                  "), (_vm.showSortArrow('SurveyIdString', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('SurveyIdString', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])]), _vm._v(" "), _c('th', {
    staticClass: "text-center sticky-header"
  }, [_c('a', {
    staticClass: "table-header",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.orderTableByColumn('KPIEvaluationRuleName')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.lang.KM0016) + "\n                  "), (_vm.showSortArrow('KPIEvaluationRuleName', true)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-top"
  }) : _vm._e(), _vm._v(" "), (_vm.showSortArrow('KPIEvaluationRuleName', false)) ? _c('span', {
    staticClass: "glyphicon glyphicon-triangle-bottom"
  }) : _vm._e()])])]), _vm._v(" "), _c('tr', {
    staticClass: "table-filters"
  }, [_c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.KPICode),
      expression: "columnFilterObject.KPICode"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.KPICode)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "KPICode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.KPIShortText),
      expression: "columnFilterObject.KPIShortText"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.KPIShortText)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "KPIShortText", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.KPILongText),
      expression: "columnFilterObject.KPILongText"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.KPILongText)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "KPILongText", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.KPIGroups),
      expression: "columnFilterObject.KPIGroups"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.KPIGroups)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "KPIGroups", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (
    !_vm.feature.isAudiTarget ||
    !_vm.feature.isEnabled('audi_importers')
  ) ? _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.ClientName),
      expression: "columnFilterObject.ClientName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.ClientName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "ClientName", $event.target.value)
      }
    }
  })])]) : _c('th', {
    staticClass: "nopadding sticky-filter"
  }), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.SurveyIdString),
      expression: "columnFilterObject.SurveyIdString"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.SurveyIdString)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "SurveyIdString", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('th', {
    staticClass: "nopadding sticky-filter"
  }, [_c('div', {
    staticClass: "form-group filterbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.columnFilterObject.KPIEvaluationRuleName),
      expression: "columnFilterObject.KPIEvaluationRuleName"
    }],
    staticClass: "form-control text-center nopadding",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM0014
    },
    domProps: {
      "value": (_vm.columnFilterObject.KPIEvaluationRuleName)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.doFiltering(), (_vm.selectedPage = 1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.columnFilterObject, "KPIEvaluationRuleName", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kpiDataOnCurrentPage), function(kpi) {
    return _c('tr', {
      key: kpi.KPIGuid,
      class: {
        info: kpi.KPIGuid === _vm.selectedKpiGuid
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedKpiGuid = kpi.KPIGuid), (_vm.selectedKpiData = kpi)
        },
        "dblclick": function($event) {
          return _vm.openKpiAssignmentDialog()
        }
      }
    }, [_c('td', [_vm._v(_vm._s(kpi.KPICode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(kpi.KPIShortText))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(kpi.KPILongText))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(kpi.KPIGroups[0].KPIGroupCode))]), _vm._v(" "), (
      !_vm.feature.isAudiTarget ||
      !_vm.feature.isEnabled('audi_importers')
    ) ? _c('td', [_vm._v("\n                " + _vm._s(kpi.ClientName) + "\n              ")]) : _c('td', [_vm._v("\n                " + _vm._s(kpi.Importers ? kpi.Importers[0].ImporterName : "") + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(kpi.Projects[0].ProjectName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(kpi.SurveyIdString))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(kpi.KPIEvaluationRuleName))])])
  }), 0)])])])]), _vm._v(" "), _c('kpi-group-edit-modal', {
    attrs: {
      "showDialog": _vm.showKpiGroupEditDialog,
      "clientList": _vm.clientList,
      "projectList": _vm.projectList,
      "kpiGroupEvaluationRulesList": _vm.kpiGroupEvaluationRulesList,
      "selectedClientForKpiGroups": _vm.selectedClient
    },
    on: {
      "dialogClosed": _vm.onKpiGroupEditDialogClosed
    }
  }), _vm._v(" "), _c('kpi-management-edit-modal', {
    attrs: {
      "showDialog": _vm.showEditKpiDialog,
      "clientList": _vm.clientList,
      "selectedClientForKpi": _vm.selectedClient,
      "selectedProjectGuidFromParent": _vm.selectedProject,
      "projectList": _vm.projectList,
      "kpiEvaluationRulesList": _vm.kpiEvaluationRulesList
    },
    on: {
      "dialogClosed": _vm.onEditKpiDialogClosed
    }
  }), _vm._v(" "), _c('kpi-assignment-modal', {
    attrs: {
      "showDialog": _vm.showKpiAssignmentDialog,
      "clientList": _vm.clientList,
      "projectList": _vm.projectList,
      "selectedClientFromParent": _vm.selectedClient,
      "selectedKpiData": _vm.selectedKpiData,
      "kpiEvaluationRulesList": _vm.kpiEvaluationRulesList,
      "kpiGroupEvaluationRulesList": _vm.kpiGroupEvaluationRulesList
    },
    on: {
      "dialogClosed": _vm.onKpiAssignmentDialogDialogClosed
    }
  }), _vm._v(" "), _c('kpi-management-translate-modal', {
    attrs: {
      "showDialog": _vm.showTranslateKpiDialog,
      "client": _vm.selectedClientForKpiTranslation,
      "projects": _vm.clientProjectList,
      "initialProject": _vm.selectedProject
    },
    on: {
      "dialogClosed": _vm.onTranslateKpiDialogClosed
    }
  }), _vm._v(" "), _c('KPICopyModal', {
    attrs: {
      "showModal": _vm.showKPICopyModal,
      "projects": _vm.clientProjectList,
      "selectedProject": _vm.selectedProject
    },
    on: {
      "copyDone": function($event) {
        return _vm.getKpiData()
      },
      "modalClosed": function($event) {
        _vm.showKPICopyModal = false
      }
    }
  })], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-toggle": "dropdown",
      "id": "elementsPerPageDropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("view_headline")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "firstPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("first_page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "role": "button",
      "id": "lastPageButton"
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("last_page")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abbfb1e6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KPIManagement/KPIManagement.vue
// module id = 650
// module chunks = 1 2